import { render, staticRenderFns } from "./EnderecoTable.vue?vue&type=template&id=a20f9c92"
import script from "./EnderecoTable.vue?vue&type=script&lang=js"
export * from "./EnderecoTable.vue?vue&type=script&lang=js"
import style0 from "./EnderecoTable.vue?vue&type=style&index=0&id=a20f9c92&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports